import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'antd';

const { Search } = Input;

const RDSearch = ({
  placeholder,
  searchStyles,
  allowClear,
  onSearch,
  searchTerm,
  handleChange,
}) => (
  <Search
    placeholder={placeholder}
    allowClear={allowClear}
    onSearch={onSearch}
    style={searchStyles}
    value={searchTerm}
    onChange={handleChange}
  />
);

RDSearch.defaultProps = {
  searchTerm: '',
  placeholder: '',
  searchStyles: {},
  allowClear: false,
  handleChange: () => {},
  onSearch: () => {},
};

RDSearch.propTypes = {
  /** The search term */
  searchTerm: PropTypes.string,
  /** Search placeholder */
  placeholder: PropTypes.string,
  /** Inline style applied to the search field */
  searchStyles: PropTypes.shape({}),
  /** If allow to remove input content with clear icon */
  allowClear: PropTypes.bool,
  /** The callback function triggered when you click on the search-icon, the clear-icon or press the Enter key */
  onSearch: PropTypes.func,
  /** Callback when user input */
  handleChange: PropTypes.func,
};

export default RDSearch;
